import PropTypes from 'prop-types';
import React from 'react';
import { useDisplayNameOrFirstName } from '~/utils/AgentUtils';

/**
 * MissedConnection
 *
 * Missed connection screen. Displayes if profile is unclaimed and user doesn't choose to message other agents.
 *
 * @param {*} props
 * @returns
 */
const MissedConnection = (props) => {
  const { nextScreen, prevScreen, agent } = props;
  const screenKey = 'MissedConnection';
  const displayNameOrFirstName = useDisplayNameOrFirstName(agent);
  return (
    <div
      className="MessageAgentForm__screen --alt --missed-connection --no-height"
      key="missedConnection"
    >
      <div className="MessageAgentForm__screen-heading --alt --narrow">
        We appreciate your interest in {displayNameOrFirstName}.
      </div>
      <div className="MessageAgentForm__screen-text --alt">
        Please check again soon.
      </div>
      <div className="MessageAgentForm__screen-controls --alt">
        <button
          className="--alt"
          type="button"
          onClick={() => {
            prevScreen({ key: screenKey });
          }}
        >
          Close
        </button>
        <button
          type="button"
          onClick={() => {
            nextScreen({ key: screenKey });
          }}
        >
          Contact other agents after all
        </button>
      </div>
    </div>
  );
};

MissedConnection.propTypes = {
  agent: PropTypes.object.isRequired,
  nextScreen: PropTypes.func.isRequired,
  prevScreen: PropTypes.func.isRequired,
};

MissedConnection.defaultProps = {
  agent: {},
  nextScreen: () => {},
  prevScreen: () => {},
};

export default MissedConnection;
